<!--
 * @Author: mzw
 * @Date: 2025-04-21 09:15:08
 * @LastEditTime: 2025-08-05 16:10:29
 * @LastEditors: mzw
 * @Description: AI工具会话（目前仅物料助手AITypeVal:4）
-->
<template>
  <div class="common-layout theme-white" ref="chatHome">
    <el-container>
      <ChatAside />

      <el-main
        v-loading="loading"
        element-loading-background="rgba(122, 122, 122, 0.3)"
        class="rf"
      >
        <div class="right-box flex-1">
          <div class="cf">
            <!-- 对话的标题 -->
            <div class="chat-title">
              {{activeChat.sessionName}}
            </div>

            <div id="container" class="cf flex-1">
              <!-- 滚动到底部按钮 -->
              <div class="to-bottom cf ac jc"
                @click="scrollToBottom"
                v-if="showScrollBottom"
              >
                <i class="el-icon-bottom"></i>
              </div>

              <div class="chat-box flex-1" ref="chatBox"  @scroll="chatListScroll">
                <!-- 会话内容为空时展示 -->
                <div v-if="isNewChat" class="blank-space cf ac jc">
                  <!-- ???? -->
                </div>

                <div v-for="item in chatData" :key="item.id" v-else>
                  <chat-prompt
                      v-if="item.type==='prompt'"
                      :itemObj="item"/>
                  <chat-reply v-else-if="item.type==='reply'"
                              :itemObj="item"
                              @answerSign='answerSign' />
                </div>
              </div><!-- end chat box -->

              <!-- v-model:prompt="prompt" -->
              <ChatInput
                ref="textInput"
                :AITypeVal="AITypeVal"
                :canSend="canSend"
                :prompt.sync="prompt"
                @uploadSuccessHandle="uploadSuccessHandle"
                @inputSendMessage="sendMessage"
                v-if="activeChat.sessionId"
                :sessionId="activeChat.sessionId"
              />
              <!-- end input box -->
              <div class="AI-warn">AI回答内容由AI生成，无法保证真实准确，仅供参考</div>

            </div><!-- end container -->
          </div><!-- end loading -->
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import ChatAside from "./components/ChatAside.vue";
import ChatPrompt from "./components/ChatPrompt.vue";
import ChatReply from "./components/ChatReply.vue";
import ChatInput from "./components/ChatInput.vue";
import { EventBus } from '@/utils/event-bus.js';
import { 
  prologue_materialAssistant,
  prologue_sourceAssistant,
  copyText_sourceAssistant
} from "./prologue";
import {
  randString,
  escapeHTML
} from "@/utils/libs";
import dayjs from 'dayjs';
// 流式数据
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { getAccessToken } from '@/utils/userInfo';
// markdown读取
import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
  html: false,
  linkify: true,  // 自动识别链接
  breaks: true // 将连续的两个换行转换为 `<br>` 标签
});

// 图标-分别对应：ChatDotRound-chat会话、Grid-智能分类、PictureFilled-OCR识别、Management-选品助手、Box-物料助手、Guide-寻源助手
const iconTypeList = ['ChatDotRound','Grid','PictureFilled', 'Management', 'Box', 'Guide']

export default {
  name: 'chatHome',
  components: {
    ChatAside,
    ChatPrompt,
    ChatReply,
    ChatInput
  },
  data () {
    return {
      loading: false,
      AITypeVal: 4, //大模型会话0,智能分类1,OCR识别2,选品助手3,物料助手4,寻源助手5
      activeChat: {}, //当前会话
      // 会话相关
      prompt: '',
      chatData: [],
      canSend : true, //是否可发送（在回答时不可发送）
      questionIdList: [], //存放会话的所有id
      isNewChat: false, // 会话内容是否为空
      // 会话分页相关
      loadingMoreChatList : false, // 是否正在加载
      finishedLoadChatList: false, // 数据是否都加载完毕
      chatListPage: 1, // 当前页码
      chatListLimit: 20, // 每页加载几条
      preScrollTopL: 0, // 滚动前，滚动条距文档顶部的距离（判断上滚还是下滚）

      //文件上传
      fileAliOssObj: null,

      // 一次提问/回答记录的参数
      questionId: '', //记录-问题创建生成的问题id
      answer: '', //记录-AI生成的答案
      questionCreate_sessionId: '', // 记录-提问时的sessionId

      showScrollBottom: false, // 是否展示滚动到底部按钮
    }
  },
  mounted () {
    this.scrollToBottom();
    EventBus.$on('loadChat', val => {
      this.loadChat(val)
    })
    this.resizeCommonHeight();
  },
  beforeDestroy() {
    EventBus.$off('loadChat')
  },
  activated () {
    this.scrollToBottom();
  },
  methods: {
    // 历史会话列表相关
    async loadChat(chat) {
      // 如果流式过程中切换会话，切换前 先将当前流式的内容写入会话答案接口中（再次进入后会将最终流式结果答案修改）
      if(!this.canSend && this.answer) {
        await this.recordQuestionAnswer();
      }

      this.AITypeVal = chat['iconType'] || 0 //初始化该会话框 AI助手类型
      if (this.activeChat['sessionId'] === chat.sessionId) {
        // 重置开场白
        this.setprologue();
        return;
      }
      this.activeChat = chat

      // this.$refs.textInput.initOcrType()
      this.chatListPage = 1
      this.getQuestionList() //获取该会话框问题列表

      // 获取最新AI助手排序
      // this.getAITypeSort()
    },
    // 设置开场白
    setprologue() {
      if([4,5].includes(this.AITypeVal)) {
        if(this.chatData.length<=0 || (this.chatData[0] && this.chatData[0].isprologue)) {
          if(this.chatData[0] && this.chatData[0].isprologue) {
            // 若有其他开场白、先去除
            this.chatData = []
          }
          if(this.AITypeVal==4) {
            // 物料助手-加载开场白（仅首次展示、不需要存到会话记录）
            const prologue = prologue_materialAssistant
            if(!prologue) return
            // 添加新的开场白
            this.chatData.push({
              type: "reply",
              id: 'reply'+ randString(32), //与问题的id(questionId)区分一下
              content: md.render(prologue),
              questionType: 'materialAssistant',
              unneedHandle: true, //不需要任何操作按钮
              isprologue: true //特殊标记，后面判断用
            });
            this.isNewChat = false
          } else if(this.AITypeVal==5) {
            // 寻源助手-加载开场白（仅首次展示、不需要存到会话记录）
            const prologue = prologue_sourceAssistant
            if(!prologue) return
            // 添加新的开场白
            this.chatData.push({
              type: "reply",
              id: 'reply'+ randString(32), //与问题的id(questionId)区分一下
              content: md.render(prologue),
              questionType: 'sourceAssistant',
              unneedHandle: true, //不需要任何操作按钮
              isprologue: true, //特殊标记，后面判断用
              copyText: copyText_sourceAssistant //复制的文案
            });
            this.isNewChat = false
          }
        }
      }
      else {
        // 其他类型-去除“物料助手”的开场白
        if(this.chatData[0] && this.chatData[0].isprologue) {
          this.chatData = []
          this.isNewChat = true
        }
      }
    },
    // 文件上传
    uploadSuccessHandle(res) {
      if (res.aliOssId) {
        this.fileAliOssObj = res
        this.sendMessage()
      }
    },
    
    // 判断是否展示滚动到底部按钮
    judgeshowScrollBottom() {
      if(this.$refs.chatBox.scrollHeight - this.$refs.chatBox.scrollTop !== this.$refs.chatBox.clientHeight) {
        this.showScrollBottom = true;
      } else {
        this.showScrollBottom = false;
      }
    },
    //上滑加载
    chatListScroll(event) {
      this.judgeshowScrollBottom();

      // 数据已全部加载完，无需再加载
      if(this.finishedLoadChatList) return
      // 加载数据
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      let scrollStep = scrollTop - this.preScrollTopL;
      if (scrollStep < 0) {
        // 向上滚
        if (scrollTop <=5 && !this.loadingMoreChatList) {
          // 当滚动到顶部，并且没有更多数据加载时
          this.loadingMoreChatList = true;
          this.getQuestionList(false);
        }
      }
      this.preScrollTopL = scrollTop;
    },
    // 获取当前会话问题列表（分页）
    getQuestionList(isToBottom=true) {
      // isToBottom是否滑倒底部，默认true
      const params = {
        sessionId: this.activeChat['sessionId'],
        page: this.chatListPage,
        limit: this.chatListLimit,
      }
      this.$http
        .post(`/help/ai/user/question/pageList`, params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          const resDataList = res.data.dataList || []
          if(this.chatListPage===1){ //第一页
            this.questionIdList = []
            this.chatData=[]
          }
          if(resDataList.length>0){
            this.isNewChat = false
            resDataList.forEach(item=>{
            // 注：resDataList需要倒叙排（用unshift将数据插在前面）
            // for (var i = resDataList.length - 1; i >= 0; i--) {
              // const item = resDataList[i]
              // 加载回答
              if(item.answerDetail){
                const itemReply = {
                  type: "reply",
                  id: 'reply'+item.questionId, //与问题的id(questionId)区分一下
                  questionId: item.questionId,
                  content: item.answerDetail.answer,
                  orgContent: item.answerDetail.answer,
                  signGood: item.answerDetail.signGood,
                  signBad: item.answerDetail.signBad,
                  downType: item.answerDetail.downType,
                  answerTime: item.answerDetail.answerTime,
                  questionType: item.questionType,
                }
                this.chatData.unshift(itemReply);
              }
              // 加载问题
              const itemPrompt = {
                type: "prompt",
                id: item.questionId,
                content: item.content,
                questionType: item.questionType,
                questionTime: item.questionTime
              }
              if(item.fileUrl){
                itemPrompt['fileAliOssObj'] = {
                  url: item.fileUrl,
                  fileType: item.fileType,
                  fileName: item.fileType,
                }
              }
              this.chatData.unshift(itemPrompt);

              this.questionIdList.unshift(item.questionId)
            // }
            })
            this.loadingMoreChatList = false;
            if(res.data.pages===res.data.currentPage){
              //最后一页
              this.finishedLoadChatList = true
            } else{
              //非最后一页
              this.chatListPage++;
              this.finishedLoadChatList = false;

              if(!isToBottom){
                nextTick(() => {
                  setTimeout(()=>{
                    //设置一点滚动条距顶部距离，保证下次能触发滚动
                    this.$refs.chatBox.scrollTop = 1;
                  },200)
                })
              }
            }

            //滑倒底部
            if(isToBottom) this.scrollToBottom()
          } else {
            this.isNewChat = true

            // 重置开场白
            this.setprologue();
          }
        })
        .catch(() => {
          this.loadingMoreChatList = false;
        });
    },
    // 好评/差评
    answerSign(data,itemObj) {
      const params = {
        ...data,
        questionId: itemObj.questionId,
        sourceType: 2 //来源类型 1:AI数字平台 2：官网平台 3：H5移动端
      }
      this.$http
        .post(`/help/ai/user/question/answerSign`, params)
        .then((res) => {
          if (res.data.code !== 0) {
            return false
          }
          //更新展示
          if(data.signBad!==undefined && data.signBad!==null) {
            // itemObj.signBad = data.signBad
            this.$set(itemObj,'signBad',data.signBad)
          }
          if(data.signGood!==undefined && data.signGood!==null) {
            // itemObj.signGood = data.signGood
            this.$set(itemObj,'signGood',data.signGood)
          }
        })
    },
    // 发送消息
    sendMessage(inputSet={}) {
      if (this.canSend === false) {
        this.$message.warning("AI 正在作答中，请稍后...");
        return
      }
      if (this.prompt.trim().length === 0 && !this.fileAliOssObj) {
        this.$message.warning("内容不能为空");
        return false;
      }

      let functionType = ''
      // 智能分类-纯文本：plainTextClassify；
      // 智能分类-文件：fileClassify；
      // 选品助手-纯文本：plainTextGoodsMatch；
      // 选品助手-文件：fileGoodsMatch；
      // OCR识别：ocr；
      // 大模型对话：bigModelChat；
      // 物料助手：materialAssistant(这个接口暂时不用，前端区分用)
      // 寻源助手：sourceAssistant
      if(this.AITypeVal===4){
        functionType = 'materialAssistant'
      }

      // let content = md.render(escapeHTML(processContent(this.prompt)))
      let contentQ = this.prompt
      let contentQEscape = escapeHTML(this.prompt) //标签等转义
      let contentQ0 = '' // 仅发送后前端追加问题消息用（使用到输入内容的需要用contentQEscape转义），而给接口的入参都无需转义（后端会转义数据）
      if(functionType==='materialAssistant'){
        if(this.fileAliOssObj){ //图片上传
          contentQ = `<img src="${this.fileAliOssObj.url}" alt="${this.fileAliOssObj.fileName}"/>`
        } else {
          contentQ = contentQ
          contentQ0 = contentQEscape
        }
      }
      // 追加消息（问题）
      this.chatData.push({
        type: "prompt",
        id: randString(32),
        content: contentQ0 || contentQ,
        fileAliOssObj: this.fileAliOssObj,
        questionType: functionType,
        questionTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
      });
      // 追加消息（AI正在作答中（后有答案要删除））
      this.chatData.push({
        type: "reply",
        id: 'reply'+ randString(32), //与问题的id(questionId)区分一下
        content: 'AI正在作答中',
        questionType: functionType,
        unneedHandle: true, //不需要任何操作按钮
        AIAnswering: true //特殊标记，后面判断用
      });

      // 如果是新会话框，更新会话名
      let modifyName = ''
      if(!this.fileAliOssObj){
        modifyName = this.prompt.slice(0, 20) //取前20个字符
      } else {
        modifyName = this.fileAliOssObj.fileName.slice(0, 20)
      }
      if(this.isNewChat || this.chatData[0].isprologue){
        EventBus.$emit('sideSessionModify',{
          sessionId: this.activeChat['sessionId'],
          sessionName: modifyName,
          iconType: this.AITypeVal
        })
        this.isNewChat=false
      }

      this.scrollToBottom();

      //会话接口请求....
      this.sendMessageAPI(functionType, contentQ, this.prompt, inputSet);
      this.prompt = '';
      this.$refs.textInput.prompt = '';
      return true;
    },
    async sendMessageAPI(functionType, contentQ, prompt, inputSet)  {
      this.canSend = false
      // 1.请求java-问题创建接口（记录问题，并生成问题id）
      const params1 = {
        sessionId: this.activeChat['sessionId'],
        questionType: functionType,
        content: contentQ,
        promptId: inputSet.promptId
      }
      this.questionCreate_sessionId = params1.sessionId
      if(this.fileAliOssObj){
        params1['fileUrl'] = this.fileAliOssObj.url
        params1['fileName'] = this.fileAliOssObj.fileName
        params1['fileType'] = this.fileAliOssObj.fileType
      }
      await this.$http
        .post(`/help/ai/user/question/create`, params1)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.questionId = res.data
          this.questionIdList.push(this.questionId)
        })
        .catch((err) => {
          if(err) this.$message.error(err.message || err);
        });

      // 2.请求AI-问题创建并获取答案回显
      let contentA = prompt
      const params2 = {
        sessionId: this.activeChat['sessionId'],
        questionId: this.questionId,
        content: contentA,
        functionType,
        sourceType: 2 //来源类型 1:AI数字平台 2：官网平台 3：H5移动端
      }
      if(this.questionIdList.length>=2){
        params2['parentQuestionId'] = this.questionIdList[this.questionIdList.length - 2]//上一次问题id
      }

      if(['materialAssistant'].includes(params2.functionType)) {
        // 物料助手/寻源助手 流式数据
        const params2_other = {
          ...params2
        }
        delete params2_other.functionType
        let fetchUrl = ''
        if(params2.functionType == 'materialAssistant') {
          fetchUrl = '/api/help/ai/user/materialAssistant/chat/stream'
          if(this.fileAliOssObj) {
            // 若是文件上传
            params2_other['fileUrl'] = this.fileAliOssObj.url
            delete params2_other.content
          }
        }
        const access_token = getAccessToken();
        const _this = this;
        await fetchEventSource(fetchUrl ,{
            openWhenHidden: true, // 当浏览器标签页被隐藏时，仍然保持连接
            method:"POST",
            headers: {
              'Content-Type': 'application/json',
              Accept: "text/event-stream",
              Authorization: `Bearer ${access_token}` || "",
            },
            body: JSON.stringify(params2_other),
            onmessage(event) {
              if(!event.data) return
              // 接收到的流式数据
              const eventData = _this.isJSON(event.data) ? JSON.parse(event.data) : event.data
              if(eventData.event == 'text_chunk') {
                const lastChatData = _this.chatData[_this.chatData.length-1]
                // 在流式过程中 中途切换会话处理
                if(!lastChatData || (!lastChatData.AIAnswering && lastChatData.questionId !=_this.questionId)) {
                  return
                }
                // 流式内容拼接
                const preContent = lastChatData.AIAnswering ? '' : lastChatData.orgContent
                const newContent = preContent + eventData.data.text
                // 流式输出内容
                // 覆盖最新一个回复内容
                _this.$set(_this.chatData, _this.chatData.length-1 , {
                  type: "reply",
                  id: 'reply'+ _this.questionId, //与问题的id(questionId)区分一下
                  questionId: _this.questionId,
                  content: md.render(newContent),
                  orgContent: newContent,
                  questionType: functionType,
                  answerTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
                })

                // answer存最后拼接的内容
                _this.answer = md.render(newContent)
              }
              // 流式结束↓
              // 内容输出过长时可能无workflow_finished，answer用上面拼接的内容
              // 正常情况下workflow_finished内存完整内容，重写上面的answer（保险）
              if(eventData.event == 'workflow_finished') {
                // 完整内容
                _this.answer = md.render( eventData.data.outputs&&eventData.data.outputs.text ? eventData.data.outputs.text : '')

                // 流程结束也没有任何输出内容↓
                if(!_this.answer) {
                  // 删除当前最后一个追加的信息（AI正在作答中）
                  if(_this.chatData[_this.chatData.length-1] && _this.chatData[_this.chatData.length-1].AIAnswering){
                    _this.chatData.pop()
                  }

                  const resHtml = '很抱歉，暂时无法回答该问题，我们将持续改进。'
                  _this.chatData.push({
                    type: "reply",
                    id: 'reply'+ _this.questionId, //与问题的id(questionId)区分一下
                    questionId: _this.questionId,
                    content: resHtml,
                    orgContent: resHtml,
                    questionType: functionType,
                    answerTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
                  });
                  _this.answer = resHtml
                }
              }

              // 判断是否在最底部，若不是则滑到最底部
              if(_this.$refs.chatBox.scrollHeight - _this.$refs.chatBox.scrollTop !== _this.$refs.chatBox.clientHeight) {
                _this.scrollToBottom();
              }
            },
            // 报错
            onerror(err) {
              _this.$message.error(err.message || '接口请求异常');

              // 删除当前最后一个追加的信息（AI正在作答中）
              if(_this.chatData[_this.chatData.length-1] && _this.chatData[_this.chatData.length-1].AIAnswering){
                _this.chatData.pop()
              }
              _this.initInputBox();

              // 终止重试↓
              throw err;
            },
            // 关闭连接
            onclose() {
              console.log('关闭连接');
            },
        });
      }

      // 3.请求java-记录问题AI的答案回复
      await this.recordQuestionAnswer();

      this.initInputBox();

      this.scrollToBottom();
    },
    // 记录/更改问题AI的答案回复
    async recordQuestionAnswer() {
      const params3 = {
        questionId: this.questionId,
        answer: this.answer,
      }
      await this.$http
        .post(`/help/ai/user/question/answer`, params3)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
        })
        .catch(err => {
          if(err) this.$message.error(err.message || err);
        })
    },
    // 初始化一些值
    initInputBox() {
      this.fileAliOssObj=null
      this.canSend = true
      this.questionId = ''
      this.answer = ''
      this.questionCreate_sessionId = ''
    },
    
    scrollToBottom() {
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.$refs.chatBox.scrollTo({ top: this.$refs.chatBox.scrollHeight, behavior: 'smooth' });
        },300)
      })
    },

    //判断是否是JSON.stringify格式
    isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj=JSON.parse(str);
          if(typeof obj == 'object' && obj ){
            return true;
          }else{
            return false;
          }
        } catch(e) {
          return false;
        }
      }
    },

    // 视图高度计算
    resizeCommonHeight() {
      const headerBox = document.querySelector('#main-content .header');
      // 设置.common-layout高度
      const chatHome = this.$refs.chatHome;
      chatHome.style.height = window.innerHeight - headerBox.offsetHeight + 'px';
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/chat/chat-plus.scss';
$rightPadding: 190px; //右侧留白多190px
.common-layout {
  // height: calc(100vh - 136px) !important; // 需要减去的header高度可能会有变动，所以用resizeCommonHeight计算
  background: url("~@/assets/img/AI/pageBg.png") no-repeat bottom rgb(236,244,254);
}

#container {
  position: relative;
  width: 1010px !important;
  padding-right: $rightPadding;
  margin: 0 auto;
}
.chat-title {
  background: rgba(255, 255, 255, 0.4);
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  color: #3D3D3D;;
  text-align: center;
  padding-right: $rightPadding;
}

.to-bottom {
  position: absolute;
  bottom: 170px;
  right: $rightPadding;
  width: 49px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(116, 183, 255, 0.3);
  font-size: 14px;
  z-index: 99;
  cursor: pointer;
  &:hover{
    background: rgb(255, 255, 255);
  }
}

.notice-dialog {
  .el-dialog__body {
    padding: 0 20px;
  }
}

.AI-type{
  // margin: 5px 10px;
  margin: 5px 150px;
}
.AI-type-box{
  width: 180px;
  ul{
    li{
      color:#1d65a8;
      font-size: 14px;
      padding: 5px;
      cursor: pointer;
      &:hover{
        background: #e8f0f6;
      }
      &.active{
        background: #e8f0f6;
      }
      .el-icon{
        margin-right: 5px;
        vertical-align: middle;
      }
    }
  }
  .other{
    color: #909399;
    margin: 25px 0;
    text-align: center;
    font-size: 12px;
  }
}

.blank-space{
  height: 100%;
  .txt-img {
    margin: 20px 0 60px;
  }
  .tool-box {
    position: relative;
    .tool-others {
      position: absolute;
      right: -25px;
      top: 50%;
      margin-top: -10px;
      .el-icon {
        font-size: 20px;
        cursor: pointer;
      }
    }
    ul{
      width: 455px;
      height: 50px;
      border-radius: 25px;
      background: #FFFFFF;
      box-shadow: var(--gradient-BoxShadow);
      li{
        flex: auto;
        cursor: pointer;
        color: #666;
        font-size: 14px;
        border-radius: 25px;
        .el-icon{
          margin-right: 8px;
        }
        &:hover{
          background: #E3ECFA;
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
          color: #000;
        }
        &.active,
        &.active:hover{
          background: var(--gradient-BtnBg);
          box-shadow: var(--gradient-BoxShadow);
          color: #fff;
        }
      }
    }
  }
}

*{
  //滚动-Webkit 样式（适用于 Chrome、Safari 等）
  ::-webkit-scrollbar { /* 定义滚动条样式 */
    width: 5px;
    height: 5px;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb { /*定义滑块 内阴影+圆角*/
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }
}
@-moz-document url-prefix() {
  *{
    //滚动-Firefox 样式（火狐浏览器）
    scrollbar-color: rgba(0, 0, 0, 0.1) transparent;
    scrollbar-width: thin;
    -ms-overflow-style: none;
  }
}
</style>